import styled from '@emotion/styled'

import color from '../../constant/colors'
import LogoFooter from '../../assets/images/base/logo-with-name-footer.svg'
import Link from '../common/TextLink'
import Text from '../common/Text'
import { mobile } from '../../utils/responsive-helper'
import { useTranslation } from 'react-i18next'
import * as path from '../../constant/path'
import BEELogo from '../../assets/images/base/BEE_LOGO.png'
import { Divider } from 'antd'

const Layout = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  background-color: ${color.CHOICES_PRIMARY};
  border-top: 1px solid ${color.BORDER};
  padding: 24px 0 40px;
  ${mobile} {
    padding-bottom: 6px;
  }
`
const Footer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1172px;
  padding: 0 16px;
  ${mobile} {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0;
    .footer-text {
      font-size: 12px;
      :nth-last-of-type(1) {
        margin-bottom: 4px;
      }
    }
  }
`
const Logo = styled.img`
  height: 32px;
  padding-top: 8px;
  ${mobile} {
    margin-bottom: 11px;
    margin-top: 4px;
  }
`
const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
`
const LinkLayout = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  > *:nth-last-of-type(1) {
    margin-left: 32px;
  }
  ${mobile} {
    justify-content: center;
    > *:nth-last-of-type(1) {
      margin-left: 16px;
      margin-bottom: 8px;
    }
  }
`
const Copyright = styled(Text)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90vw;
`
const FooterContentLayout = styled(Layout)`
  border-top: unset;
  min-height: unset;
  height: unset;
  ${mobile} {
    border-top: unset;
    min-height: unset;
    height: unset;
    padding-bottom: unset;
  }
`
const FooterContent = styled.div`
  width: 100%;
  max-width: 1172px;
  display: flex;
  flex-direction: column;
  padding: 0 16px;
`

const AppFooter = () => {
  const { t } = useTranslation()
  const currentLogo = BEELogo

  return (
    <div style={{ marginTop: 'auto' }}>
      <Layout>
        <Footer>
          <div style={{ backgroundColor: color.WHITE, padding: '0 8px 8px', borderRadius: 8, width: 'fit-content' }}>
            <Logo src={currentLogo} />
          </div>
          <FlexColumn>
            {/* <LinkLayout>
              <Link
                className="footer-text"
                type="Medium"
                color={color.FONT_BLACK}
                path={path.termAndCondition()}
              >
                {t('footer.link.privacyAndTerms')}
              </Link>
              <Link
                className="footer-text"
                type="Medium"
                color={color.FONT_BLACK}
                path={path.contact()}
              >
                {t('footer.link.contactUs')}
              </Link>
            </LinkLayout> */}
            <Divider style={{ backgroundColor: color.BACKGROUND_LIGHT_GRAY }} />
            <Copyright
              style={{ marginTop: 6, fontSize: 12 }}
              color={color.WHITE}
            >
              © 2025 BEE. All rights reserved | นโยบายความเป็นส่วนตัว
            </Copyright>
          </FlexColumn>
        </Footer>
      </Layout>
    </div>
  )
}

export default AppFooter
